// extracted by mini-css-extract-plugin
export default {"container":"_0-z","heading":"a1-z","links":"b1-z","copy":"c1-z","subCopy":"d1-z","linksLeft":"e1-z","linksCenter":"f1-z","linksRight":"g1-z","link":"h1-z","onlyLink":"i1-z"};